<template>
  <div class="demand-status-label" :style="styles">
    <QIcon :name="icon" />
    <span>{{ label }}</span>
  </div>
</template>

<script>
  import { DEMAND_TYPES } from "@core/constants";
  import { dashboardDemandMixin } from "@etab/mixins";

  export default {
    mixins: [dashboardDemandMixin],
    props: {
      contractType: {
        type: String,
        default: "",
      },
      candidateAppliedCount: {
        type: Number,
        default: 0,
      },
      candidateSelectedCount: {
        type: Number,
        default: 0,
      },
      candidateCancellationCount: {
        type: Number,
        default: 0,
      },
      isDemandFilled: {
        type: Boolean,
        default: false,
      },
      isFavorite: {
        type: Boolean,
        default: false,
      },
      demandColor: {
        type: String,
        default: "",
      },
      hasCandidate: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      icon() {
        if (this.isDemandFilled || this.candidateSelectedCount) {
          return "fad fa-circle-check";
        }
        if (this.candidateAppliedCount > 0 && !this.isFavorite) {
          return "fad fa-clock-rotate-left";
        }
        if (this.candidateCancellationCount) {
          return "fad fa-circle-exclamation";
        }
        return "fad fa-clock";
      },
      label() {
        switch (this.contractType) {
          case DEMAND_TYPES.AE:
            if (this.isDemandFilled && this.isFavorite) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@FAVORITE_BOOKED");
            }
            if (this.isDemandFilled) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DEMAND_FILLED");
            }
            if (this.isFavorite) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@FAVORITE_EXTRA");
            }
            if (this.candidateSelectedCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_SELECTED_CANDIDATES", this.candidateSelectedCount);
            }
            if (this.candidateCancellationCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CANCELLATION_CANDIDATES", this.candidateCancellationCount);
            }
            return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CURRENT_CANDIDATES", this.candidateAppliedCount);
          case DEMAND_TYPES.INTERIM:
            if (this.isDemandFilled && this.isFavorite) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@FAVORITE_BOOKED");
            }
            if (this.isDemandFilled) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DEMAND_FILLED");
            }
            if (this.isFavorite) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@FAVORITE_EXTRA");
            }
            if (this.candidateSelectedCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_SELECTED_CANDIDATES", this.candidateSelectedCount);
            }
            if (this.candidateCancellationCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CANCELLATION_CANDIDATES", this.candidateCancellationCount);
            }
            return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CURRENT_CANDIDATES", this.candidateAppliedCount);
          case DEMAND_TYPES.CDI:
            if (this.candidateSelectedCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CONTACTED_CANDIDATES", this.candidateSelectedCount);
            }
            if (this.isDemandFilled) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DEMAND_FILLED");
            }
            return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CURRENT_CANDIDATES", this.candidateAppliedCount);
          case DEMAND_TYPES.SEASON:
            if (this.candidateSelectedCount) {
              return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CONTACTED_CANDIDATES", this.candidateSelectedCount);
            }
            if (this.isDemandFilled) {
              return this.$t("ETAB.PAGES.RECRUITMENT.TILE.@DEMAND_FILLED");
            }
            return this.$tc("ETAB.PAGES.RECRUITMENT.TILE.@TOTAL_CURRENT_CANDIDATES", this.candidateAppliedCount);
          default:
            return "";
        }
      },
      styles() {
        let color = null;
        if (!this.hasCandidate) {
          color = this.$_colors.third;
        }
        if (this.candidateCancellationCount) {
          color = this.$_colors.danger;
        }
        if (this.candidateSelectedCount) {
          color = this.$_colors.success;
        }
        return {
          color: color || this.demandColor,
        };
      },
    },
  };
</script>

<style lang="scss" scoped>
  .demand-status-label {
    display: flex;
    align-items: baseline;
    span {
      margin-left: 5px;
    }
  }
</style>
